// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { checkQuotaAvailability, checkTrialAvailability } from "./operations.js";
export {
  LocationsCheckQuotaAvailabilityOptionalParams,
  LocationsCheckTrialAvailabilityOptionalParams,
} from "./options.js";
